import * as React from "react";
import PropTypes from "prop-types";
import { useEffect, useState } from "react";
import "./MethodMobile.scss";
import { Container, Image } from "react-bootstrap";
import MethodArrow from "../MethodArrow/MethodArrow";
import CallToAction from "../../CallToAction/CallToAction";
import MethodSplitImage from "../MethodSplitImage/MethodSplitImage";
import { GatsbyImage, getImage } from "gatsby-plugin-image";

const MethodMobile = (props) => {
  const [title, setTitle] = useState(null);
  const data = props.data;

  useEffect(() => {
    setTitle(data.title.split(" "));
  }, [data]);

  return (
    <div className="method-container-mobile">
      <Container fluid>
        <div className="method-title">
          <div>{title && title[0] + " " + title[1]}</div>
          <div>{title && title[2]}</div>
        </div>
      </Container>
      <MethodSplitImage
        image={data && data.images1[0]}
        orientation="horizontal"
        isBoxed={true}
      />
      <div className="method-first-second-container">
        <Container fluid>
          <Image
            className="method-numbers"
            src={data && data.numbers[3].file.url}
          />
          <div className="method-subtitles">{data && data.title1}</div>
          <div className="method-text">{data && data.text1.text1}</div>
          <Image
            className="method-numbers"
            src={data && data.numbers[2].file.url}
          />
        </Container>
      </div>
      <GatsbyImage image={data && getImage(data.images2[0])} alt="" />
      <div className="method-third-container">
        <Container fluid>
          <div className="method-subtitles">{data && data.title2}</div>
          <div className="method-text">{data && data.text2.text2}</div>
          <div className="text-center my-2">
            <GatsbyImage
              image={data && getImage(data.images3[0])}
              alt=""
              imgClassName="method-image-100"
            />
          </div>
          <Image
            className="method-numbers"
            src={data && data.numbers[1].file.url}
          />
          <div className="method-subtitles">{data && data.title3}</div>
          <div className="method-text">{data && data.text3.text3}</div>
        </Container>
      </div>
      <GatsbyImage image={data && getImage(data.images4[0])} alt="" />
      <div className="method-fourth-container">
        <Container fluid>
          <Image
            className="method-numbers"
            src={data && data.numbers[0].file.url}
          />
          <div className="method-subtitles">{data && data.title4}</div>
          <div className="method-text">{data && data.text4.text4}</div>
        </Container>
        <MethodArrow orientation="vertical" className="mx-auto" />
      </div>
      <MethodSplitImage
        image={data && data.bottomImage}
        orientation="horizontal"
        isBoxed={true}
      />
      <div className="method-fifth-container">
        <Container fluid>
          <div className="method-text">
            {data && data.bottomText.bottomText}
          </div>
          <div className="method-text bottom-link">
            <CallToAction
              label={data && data.bottomLinkText.toUpperCase()}
              to={data && data.bottomLinkUrl}
            />
          </div>
        </Container>
      </div>
    </div>
  );
};

MethodMobile.propTypes = {
  data: PropTypes.object.isRequired,
};

export default MethodMobile;
